<template>
    <router-view />
</template>

<script>
export default {
    name: 'Main-Layout'
}
</script>